<template>
  <div
    class="product-box product-box--searched product-box--featured v-product-item">
    <div class="product-box__images">
      <a :href="`/products/${handle}`">
        <div class="product-image">
          <img alt="main-image" :src="mainImage">
          <img
            v-if="hoverImage"
            id="ProductCardImage-header-1883398963251-1"
            class="image--hover"
            alt="GIF-hover"
            :src="hoverImage">
        </div>
      </a>
    </div>
    <div class="product-box--top-searched-box">
      <div class="product-box__title product-box--white-background product-box--fix-height product-box__top-searched">
        <a :href="`/products/${handle}`">
          {{ title }}
        </a>
      </div>

      <div class="product-box--regular-product">
        <div class="price-box">
          <div v-if="priceCompare.length > 0" class="price-box__sale">
            {{ originalPrice }}
          </div>
          <div v-if="priceCompare.length > 0" class="price-box__compare">
            {{ compareAtPrice }}
          </div>

          <div v-if="priceCompare.length == 0" class="price-box__regular">
            {{ originalPrice }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductItem",
  computed: {
    originalPrice() {
      return '$' + (Number(this.price) / 100).toFixed(2)
    },
    compareAtPrice() {
      return '$' + (Number(this.priceCompare) / 100).toFixed(2)
    }
  },
  props: {
    mainImage: { type: String, required: true},
    hoverImage: { type: String, required: true},
    title: { type: String, required: true},
    price: { type: String, required: true},
    priceCompare: { type: String, required: false},
    handle: { type: String, required: false}
  }
}
</script>

<style lang="scss" scoped>
  .v-product-item {
    padding: 0 10px;
  }
</style>